// App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './components/home';
import NavBar from './components/navbar';
import ProductDetail from './components/productdetail';
// import Cart from './components/Cart'; 
import AddProduct from './components/addproducts';
import AdminLogin from './components/AdminLogin';
import Cartpage from './components/cartpage';
import CheckoutPage from './components/CheckoutPage';
import SuccessCard from './components/Success';
import NotFound404 from './components/PageNotFound';
import AdminOrders from './components/AdminOrders';
import AdminOrdersDetails from './components/AdminOrderDetails';



import { CartProvider } from './context/CartContext';

// import { CartProvider } from './context/CartContext';
import './styles/home.css';
import './styles/SalesContainer.css';
import './styles/StyledDelivery.css';
import './styles/subscription.css';
import './styles/footer.css';

function App() {
  return (
    <CartProvider>
      <Router>
        <div>
          <NavBar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/product/:id" element={<ProductDetail />} />
            {/* <Route path="/cart" element={<Cart />} />  */}
            <Route path="/add-product" element={<AddProduct />} />
            <Route path="/admin-login" element={<AdminLogin />} />
            <Route path="/cartpage" element={<Cartpage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/success" element={<SuccessCard />} />
            <Route path="*" element={<NotFound404 />} />
            <Route path="/admin/orders" element={<AdminOrders />} />
            <Route path="/admin/orders/:id" element={<AdminOrdersDetails />} />

            {/* Catch-all route for 404 */}
          </Routes>
        </div>
      </Router>
    </CartProvider>
  );
}

export default App;
